import { render, staticRenderFns } from "./estrattiContoNetwork.vue?vue&type=template&id=3e89d4d9&"
import script from "./estrattiContoNetwork.vue.ts?vue&type=script&lang=ts&"
export * from "./estrattiContoNetwork.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports